import { Fuel } from '~/graphql';

import { VehicleType, VehicleTypeFuelSetting } from './vehicleTypes.types';

export const getFuelSetting = (vt: VehicleType, fuel: Fuel): VehicleTypeFuelSetting | undefined =>
    vt.fuelSettings.find(fc => fc.fuel === fuel);

export const fuelList = [Fuel.Diesel, Fuel.HVO100, Fuel.Electric];
